import React from 'react';
import { GiBroom } from "react-icons/gi";
import { Row, Button, Col, Card } from 'reactstrap';

//Componentes auxiliares:
import CustomDatePicker from './CustomDatePicker';

let DateFilterManager = (props) => {
    return (
        <Card>
            <div className="card-body">
                <Row>
                    <Col xs="8" md="8" lg="8" xl="8" style={{ display: "flex", alignItems: "center" }}>
                        <h6 className="card-title noselect" style={{ cursor: "pointer", marginBottom: 0 }} >
                            <p style={{ fontSize: 10, marginBottom: 0 }}>{props.title || "Filtro por Fechas:"}</p>
                        </h6>
                    </Col>

                    <Col xs="4" md="4" lg="4" xl="4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                        <Button
                            onClick={props.resetDates}
                            className="btn btn-default"
                            style={{ padding: "3px 10px", backgroundColor: "transparent", color: "#65615c", marginLeft: 5 }}>
                            <GiBroom />
                        </Button>
                    </Col>
                </Row>

                <Row style={{ justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <CustomDatePicker
                        title="Fecha inicial:"
                        onChange={props.updateFromDate}
                        currentDate={props.currentFromDate} />

                    <CustomDatePicker
                        title="Fecha final:"
                        onChange={props.updateToDate}
                        currentDate={props.currentToDate} />
                </Row>

                <Row style={{ flexDirection: "column", alignItems: "center", paddingTop: 15, paddingLeft: "5%", paddingRight: "5%" }}>
                    <p className="card-category" style={{ marginBottom: 5, fontSize: 10, textTransform: "uppercase" }}>
                        <b>{getQuantityDescription(props)}</b>
                    </p>
                </Row>
            </div>
        </Card>
    );
}

let getQuantityDescription = (props) => {
    let activeQuantity = props.activeQuantity;
    if (props.activeQuantity >= props.totalRegisters) { activeQuantity = props.totalRegisters }
    if (props.totalRegisters < props.activeQuantity) { activeQuantity = props.totalRegisters }

    return ("Estoy viendo " + activeQuantity + " registros de " + props.totalRegisters);
}

export default DateFilterManager;